"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconKey = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20,16.8 L20,20 L16.8,20 L16.8,17.6 L14.4,17.6 L14.4,15.2 L12,15.2 L10.192,13.392 C9.752,13.528 9.288,13.6 8.8,13.6 C6.1490332,13.6 4,11.4509668 4,8.8 C4,6.1490332 6.1490332,4 8.8,4 C11.4509668,4 13.6,6.1490332 13.6,8.8 C13.6,9.288 13.528,9.752 13.392,10.192 L20,16.8 M8,6.4 C7.1163444,6.4 6.4,7.1163444 6.4,8 C6.4,8.8836556 7.1163444,9.6 8,9.6 C8.8836556,9.6 9.6,8.8836556 9.6,8 C9.6,7.1163444 8.8836556,6.4 8,6.4 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconKey')(IconKey);